import useReader from './useReader';

export default useReader;
